import React from 'react';
import { Header } from '../components/Header';
import { AngelikaSturnFooter } from '../components/AngelikaSturnFooter';
export function AngelikaSturnProfilPage() {
  return <div className="min-h-screen bg-white" data-id="element-830">
      <Header data-id="element-831" />
      <main className="w-full pt-[152px]" data-id="element-832">
        <div className="w-full flex justify-center" data-id="element-833">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-834">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fZrGTWuRbQfNPcwxck1wYe/Header-Profil-Angelika_Sturny.jpg" alt="Dr. Angelika Sturny" className="w-full h-full object-cover" data-id="element-835" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-836"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-24" data-id="element-837">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-838">
                <div className="max-w-lg text-left" data-id="element-839">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-840">
                    "Das größte Geschenk, das ich von jemandem empfangen kann,
                    ist, gesehen, gehört, verstanden und berührt zu werden"
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-841">
                    – Virginia Satir, Psychotherapeutin
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-842">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-843">
            Profil
          </h1>
          <div className="text-lg text-gray-600 leading-relaxed space-y-6 mb-8" data-id="element-844">
            <p data-id="element-845">
              Ich bin promovierte Diplom-Psychologin und begleite Menschen als
              Psychotherapeutin, Coach und systemische Familientherapeutin – ob
              Einzelpersonen, Paare, Familien oder Kinder und Jugendliche.
            </p>
            <p data-id="element-846">
              Mit meiner staatlichen Zulassung als Heilpraktikerin für
              Psychotherapie und über 25 Jahren Erfahrung in der
              Personalentwicklung eines DAX-Unternehmens sowie in NGOs verbinde
              ich psychologisches Fachwissen mit praxisnaher Expertise.
            </p>
          </div>
          <div className="mb-4" data-id="element-847">
            <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-6" data-id="element-848">
              Meine Motivation
            </h2>
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-849">
              <p data-id="element-850">
                Die Verbindung von beruflicher Expertise, familiärer Erfahrung
                und sozialem Engagement bildet das Fundament meiner Arbeit als
                systemische Familientherapeutin. Ich weiß, wie herausfordernd
                Beziehungen sein können – und wie viel Kraft in ehrlichem
                Kontakt, gegenseitigem Verständnis und gemeinsamer Entwicklung
                liegt.
              </p>
              <p data-id="element-851">
                Meine therapeutische Haltung ist geprägt von Wertschätzung,
                Klarheit und einem tiefen Vertrauen in die Ressourcen jedes
                Menschen. Ich glaube daran, dass Veränderung möglich ist – wenn
                wir bereit sind, hinzuschauen, zu verstehen und neue Wege zu
                gehen.
              </p>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg" data-id="element-852">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-853">
            Was mich ausmacht
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-854">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-855">
              <ul className="space-y-5" data-id="element-856">
                <li className="flex items-start" data-id="element-857">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-858"></div>
                  <div data-id="element-859">
                    <p className="text-gray-600" data-id="element-860">
                      Ganzheitlicher Blick auf Beziehungen, wiederkehrende
                      Muster und individuelle wie gemeinsame
                      Entwicklungsprozesse
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-861">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-862"></div>
                  <div data-id="element-863">
                    <p className="text-gray-600" data-id="element-864">
                      Langjährige Erfahrung in der Arbeit mit Menschen in
                      komplexen Lebenssituationen
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-865">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-866"></div>
                  <div data-id="element-867">
                    <p className="text-gray-600" data-id="element-868">
                      Empathie und ein geschützter Raum für persönliche Prozesse
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-869">
              <ul className="space-y-5" data-id="element-870">
                <li className="flex items-start" data-id="element-871">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-872"></div>
                  <div data-id="element-873">
                    <p className="text-gray-600" data-id="element-874">
                      Seit über 20 Jahren verheiratet und Mutter eines
                      erwachsenen Sohnes
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-875">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-876"></div>
                  <div data-id="element-877">
                    <p className="text-gray-600" data-id="element-878">
                      Engagement für soziale Gerechtigkeit und Gewaltprävention
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-879">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-880"></div>
                  <div data-id="element-881">
                    <p className="text-gray-600" data-id="element-882">
                      Seit über 30 Jahren aktiv in der Fachberatungsstelle
                      Frauennotruf Heidelberg gegen sexuelle Gewalt an Frauen
                      und Mädchen – aktuell erneut als Vorstandsmitglied
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-883">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-884">
            Qualifikationen
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-885">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-886">
              <ul className="space-y-5" data-id="element-887">
                <li className="flex items-start" data-id="element-888">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-889"></div>
                  <div data-id="element-890">
                    <p className="text-gray-700 font-medium" data-id="element-891">
                      Promotion an der Universität Saarbrücken (Dr. phil.)
                    </p>
                    <p className="text-gray-600" data-id="element-892">
                      Wirtschaft- und Sozialpsychologie
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-893">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-894"></div>
                  <div data-id="element-895">
                    <p className="text-gray-700 font-medium" data-id="element-896">Studium</p>
                    <p className="text-gray-600" data-id="element-897">
                      Klinische Psychologie an der Universität Landau/Pfalz,
                      Heidelberg und an der University Brunel, Uxbridge, London
                      (UK)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-898">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-899"></div>
                  <div data-id="element-900">
                    <p className="text-gray-700 font-medium" data-id="element-901">
                      Weiterbildung zur systemisch-integrativen Paar- und
                      Familientherapeutin (DGSF)
                    </p>
                    <p className="text-gray-600" data-id="element-902">
                      Münchener Institut für Systemisch-Integrative Therapie
                      (MiSiT e.V.)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-903">
              <ul className="space-y-5" data-id="element-904">
                <li className="flex items-start" data-id="element-905">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-906"></div>
                  <div data-id="element-907">
                    <p className="text-gray-700 font-medium" data-id="element-908">
                      Weiterbildung am Institut für systemische Beratung,
                      Wiesloch bei Heidelberg (isb)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-909">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-910"></div>
                  <div data-id="element-911">
                    <p className="text-gray-700 font-medium" data-id="element-912">
                      Zertifizierung als Coach durch Korn Ferry
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-913">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-914"></div>
                  <div data-id="element-915">
                    <p className="text-gray-700 font-medium" data-id="element-916">
                      Heilpraktikerin für Psychotherapie
                    </p>
                    <p className="text-gray-600" data-id="element-917">Zulassung in Bayern</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-918">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-919">
            Berufliche Stationen und internationale Erfahrung
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-920">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-921">
              <ul className="space-y-5" data-id="element-922">
                <li className="flex items-start" data-id="element-923">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-924"></div>
                  <div data-id="element-925">
                    <p className="text-gray-600" data-id="element-926">
                      Munich Re: Seit 2001 Konzernerfahrung in unterschiedlichen
                      globalen HR Rollen (u.a. Globales Talent Management sowie
                      strategische Rollen im Business)
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-927">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-928"></div>
                  <div data-id="element-929">
                    <p className="text-gray-600" data-id="element-930">
                      Geschäftsführerin beim Verein zur Förderung politischen
                      Handelns (vfh) in Bonn
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-931">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-932"></div>
                  <div data-id="element-933">
                    <p className="text-gray-600" data-id="element-934">
                      Lehrbeauftragte an der Universität Saarbrücken für
                      Sozialpsychologie
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-935">
              <ul className="space-y-5" data-id="element-936">
                <li className="flex items-start" data-id="element-937">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-938"></div>
                  <div data-id="element-939">
                    <p className="text-gray-600" data-id="element-940">
                      Drogen- und Suchtberatung bei Prop Shop, Freising
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-941">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-942"></div>
                  <div data-id="element-943">
                    <p className="text-gray-600" data-id="element-944">
                      Isar-Amper-Klinikum, Region München
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-945">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-946"></div>
                  <div data-id="element-947">
                    <p className="text-gray-600" data-id="element-948">
                      Klinik für Psychiatrie und Psychotherapie, München
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-949">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-950"></div>
                  <div data-id="element-951">
                    <p className="text-gray-600" data-id="element-952">
                      UNICEF, New York, und Bundesministerium für
                      wirtschaftliche Zusammenarbeit und Entwicklung (BMZ), Bonn
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8" data-id="element-953">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-954">
            Publikationen
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-955">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-956">
              <ul className="space-y-5" data-id="element-957">
                <li className="flex items-start" data-id="element-958">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-959"></div>
                  <div data-id="element-960">
                    <p className="text-gray-600" data-id="element-961">
                      Rekrutierungsstrategien für internationale Trainees bei
                      einem globalen Rückversicherer – ein Fallbeispiel,
                      Springer Verlag 2024 in Hrsg. Heinke Steiner. Online
                      Assessment-Grundlagen und Anwendung von Online Tests in
                      der Unternehmenspraxis, 2. Auflage
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-962">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-963"></div>
                  <div data-id="element-964">
                    <p className="text-gray-600" data-id="element-965">
                      Ansatzpunkte für eine Integration von mehr Frauen in
                      Führungspositionen, Deutsche Gesellschaft für
                      Personalführung, März 2012
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-966">
              <ul className="space-y-5" data-id="element-967">
                <li className="flex items-start" data-id="element-968">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-969"></div>
                  <div data-id="element-970">
                    <p className="text-gray-600" data-id="element-971">
                      Spannungsfeld Berufsdomäne – wirkt sich die Tätigkeit in
                      einer Männer- und Frauendomäne negativ auf das
                      Karriereverhalten von Frauen und Männern aus? Bertuch
                      Verlag, 1. Mai 2005
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-972">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-973"></div>
                  <div data-id="element-974">
                    <p className="text-gray-600" data-id="element-975">
                      Angelika Scholbeck (heute Sturny): Das Karriereverhalten
                      von Frauen und Männern in unterschiedlichen Berufsdomänen
                      – empirische Untersuchung im Ingenieurswesen, Pflege- und
                      Ärztebereich, Röhrig Universitätsverlag, 1. Februar 2001
                      (Dissertation: Wirtschaftspsychologie)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto pb-8 px-6 md:px-12 bg-gray-50 py-12 rounded-lg mt-8 mb-24" data-id="element-976">
          <h2 className="text-2xl md:text-2xl font-light text-gray-700 mb-8 text-center" data-id="element-977">
            Ehrenamt
          </h2>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-978">
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-979">
              <ul className="space-y-5" data-id="element-980">
                <li className="flex items-start" data-id="element-981">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-982"></div>
                  <div data-id="element-983">
                    <p className="text-gray-600" data-id="element-984">
                      5 Jahre Stadträtin in Heidelberg (1994-1999)
                      (Schwerpunkte: Stadtentwicklung, Soziales, Kinder- und
                      Frauenpolitik), Aufsichtsrat u.a. Volkshochschule
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-985">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-986"></div>
                  <div data-id="element-987">
                    <p className="text-gray-600" data-id="element-988">
                      Seit 1991 Mitglied der Fachberatungsstelle gegen
                      sexualisierte Gewalt des Frauennotrufs Heidelberg; seit
                      2022 Vorstandsmitglied
                    </p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg" data-id="element-989">
              <ul className="space-y-5" data-id="element-990">
                <li className="flex items-start" data-id="element-991">
                  <div className="flex-shrink-0 h-2 w-2 rounded-full bg-[#cda8be] mt-2.5 mr-3" data-id="element-992"></div>
                  <div data-id="element-993">
                    <p className="text-gray-600" data-id="element-994">
                      2 Jahre Mitglied des Vorstandes TAMAD (Freunde des Tel
                      Aviv Museum, Kinderfriedensprojekt in Tel Aviv)
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <AngelikaSturnFooter data-id="element-995" />
    </div>;
}